import type {Model} from '@github-ui/marketplace-common'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {testIdProps} from '@github-ui/test-id-props'
import type {ShowModelPayload} from '../../../types'
import styles from './Readme.module.css'

import {VerifiedHTMLBox} from '@github-ui/safe-html/VerifiedHTML'

export function Readme() {
  const {model, modelReadme} = useRoutePayload<ShowModelPayload>()

  return (
    <>
      <MarkdownPublisherHeroImage model={model} />
      <VerifiedHTMLBox data-hpc html={modelReadme} className="tmp-p-3" {...testIdProps('readme-content')} />
    </>
  )
}

const MarkdownHero = ({src, webp, alt}: {src: string; webp: string; alt: string}) => {
  return (
    <div className={styles.markdownHeroContainer} {...testIdProps('readme-hero')}>
      <picture>
        <source srcSet={webp} type="image/webp" />
        <img className={styles.markdownHeroLogo} src={src} alt={alt} />
      </picture>
    </div>
  )
}

function MarkdownPublisherHeroImage({
  model: {publisher, publisherSlug},
}: {
  model: Pick<Model, 'publisher' | 'publisherSlug'>
}) {
  switch (publisherSlug) {
    case 'cohere':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/cohere-hero.jpg"
          webp="/images/modules/marketplace/models/families/cohere-hero.webp"
          alt={publisher}
        />
      )
    case 'core42':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/core42-hero.jpg"
          webp="/images/modules/marketplace/models/families/core42-hero.webp"
          alt={publisher}
        />
      )
    case 'deepseek':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/deepseek-hero.jpg"
          webp="/images/modules/marketplace/models/families/deepseek-hero.webp"
          alt={publisher}
        />
      )
    case 'meta':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/meta-hero.jpg"
          webp="/images/modules/marketplace/models/families/meta-hero.webp"
          alt={publisher}
        />
      )
    case 'microsoft':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/microsoft-hero.jpg"
          webp="/images/modules/marketplace/models/families/microsoft-hero.webp"
          alt={publisher}
        />
      )
    case 'mistral-ai':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/mistral-hero.jpg"
          webp="/images/modules/marketplace/models/families/mistral-hero.webp"
          alt={publisher}
        />
      )
    case 'ai21-labs':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/ai21labs-hero.jpg"
          webp="/images/modules/marketplace/models/families/ai21labs-hero.webp"
          alt={publisher}
        />
      )
    case 'openai':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/openai-hero.jpg"
          webp="/images/modules/marketplace/models/families/openai-hero.webp"
          alt={publisher}
        />
      )
    case 'xai':
      return (
        <MarkdownHero
          src="/images/modules/marketplace/models/families/xai-hero.jpg"
          webp="/images/modules/marketplace/models/families/xai-hero.webp"
          alt={publisher}
        />
      )
    default:
      return null
  }
}
